
export class HbsmrIdentity {

    public static fetch(): Promise<HbsmrUser> {      
        return new Promise<HbsmrUser>(
            function (resolve, reject) {
                $.getJSON("/api/hbsmridentity/get", function (response) {
                    resolve(response);
                }).fail(function () {
                    resolve(null);
                });
            }
        );
    }

}

export class HbsmrUser {
    public userId: string;   
    public roles: Array<string>;
}